import { AxiosResponse } from 'axios';
import { Result } from '@/main/models/common/resultResponse';
import { KeyValue } from '@/main/models/common';
import { IntegrationQueueRequest } from '@/main/models/request';
import { IntegrationQueueResponse } from '@/main/models/response';
import { PaginationResponse } from '@/main/models/common/paginationResponse';

export abstract class IIntegrationQueueApi {
  abstract getDomainStatus(): Promise<AxiosResponse<Result<KeyValue>>>;

  abstract getSearchGrid(
    request: IntegrationQueueRequest
  ): Promise<AxiosResponse<PaginationResponse<IntegrationQueueResponse[]>>>;

  abstract updateQueueStatus(
    guidIntegrationQueue: string
  ): Promise<AxiosResponse<Result<void>>>;

  abstract resend(
    guidIntegrationQueue: string
  ): Promise<AxiosResponse<Result<void>>>;
}

